// removed by extract-text-webpack-plugin
module.exports = {"gridContainer":"_2VlBd","item":"_6wnsp","image":"_6zKww","itemDetails":"_2X6ct"};